// Real Danish copy from MM Byggeri & Rådgivning
export const translations = {
    da: {
        nav: {
            home: "Forside",
            cases: "Cases",
            private: "Privat",
            architects: "Arkitekter",
            about: "Om os",
            contact: "Kontakt",
        },
        home: {
            eyebrow: "København  ·  Nordsjælland",
            heroLine1: "Arkitektur fortjener",
            heroLine2: "håndværk",
            heroLine3: "der kan følge med.",
            heroSubtitle:
                "Vi skaber eksklusive renoveringer, tilbygninger og sommerhuse, hvor arkitektur, materialer og udførelse hænger sammen som en helhed. Med rådgivning i øjenhøjde, medaljetømrere på pladsen og respekt for detaljerne omsætter vi visioner til boliger, der holder i generationer.",
            scrollHint: "Rul ned",
            positioningLabel: "— Position",
            positioning:
                "Vi skaber eksklusive renoveringer, tilbygninger og sommerhuse for mennesker, der værdsætter arkitektur, materialer og godt håndværk. Med respekt for visionen og øje for detaljen skaber vi sammenhæng mellem idé, rådgivning og udførelse.",
            selectedWorkLabel: "Udvalgte projekter",
            selectedWorkTitle: "Et arbejde formet af detalje",
            viewAll: "Se alle projekter",
            audienceLabel: "Vi arbejder for",
            forPrivateTitle: "Den private bygherre",
            forPrivateText:
                "For dig, der ønsker en renovering, tilbygning eller et sommerhus, hvor kvalitet, materialer og detaljer er tænkt ind fra begyndelsen. Vi skaber overblik gennem hele processen og omsætter visioner til løsninger, der holder i mange år.",
            forPrivateCta: "For private",
            forArchTitle: "Arkitekten",
            forArchText:
                "For arkitekter, der søger en udførende samarbejdspartner med forståelse for detaljen, materialerne og intentionen bag tegningen. Vi arbejder med respekt for arkitekturen og leverer den kvalitet, projektet er tegnet til.",
            forArchCta: "For arkitekter",
            ctaTitle: "Lad os tale om dit projekt",
            ctaText:
                "Uanset om du står foran en renovering, en tilbygning eller et nyt sommerhus, starter et godt resultat med den rigtige dialog. Vi tager gerne en uforpligtende snak om dine tanker, ambitioner og muligheder.",
            ctaButton: "Kontakt os",
            servicesLabel: "— Hvad vi gør",
            servicesTitle: "Tre discipliner.\nEn kompromisløs standard.",
            s1Title: "Renovering",
            s1Text:
                "Vi forvandler eksisterende boliger med respekt for arkitekturen, materialerne og de detaljer, der giver huset sin karakter.",
            s2Title: "Tilbygning",
            s2Text:
                "Vi skaber tilbygninger, der opleves som en naturlig del af boligen og forbinder nyt og eksisterende i én samlet helhed.",
            s3Title: "Sommerhus",
            s3Text:
                "Vi opfører sommerhuse med fokus på ro, kvalitet og gennemtænkte løsninger, hvor arkitektur og omgivelser spiller sammen.",
            uspLabel: "— Hvad gør os unikke",
            uspTitle: "Tre principper.\nÉt fundament.",
            usp1: "Vi er vokset op med byggeriet, og det kan mærkes i måden vi tænker detaljer, materialer og kvalitet på.",
            usp2: "Vi bygger med medaljetømrere og folk, der tager håndværket personligt — helt ned til den sidste finish.",
            usp3: "Vi skaber eksklusive løsninger, hvor arkitektens vision omsættes med respekt for materialer, proportioner og detaljer.",
        },
        cases: {
            eyebrow: "Projekter",
            title: "Cases",
            intro:
                "Eksklusive renoveringer, tilbygninger og sommerhuse skabt med respekt for arkitektur, materialer og detalje.",
            filterAll: "Alle",
            filterRenovation: "Renovering",
            filterExtension: "Tilbygning",
            filterSummerhouse: "Sommerhus",
            viewProject: "Se projekt",
        },
        caseDetail: {
            backToCases: "Tilbage til cases",
            location: "Beliggenhed",
            year: "År",
            type: "Type",
            architect: "Arkitekt",
            scope: "Omfang",
            overview: "Overblik",
            materials: "Materialer",
            nextProject: "Næste projekt",
        },
        privat: {
            eyebrow: "For den private bygherre",
            title: "Et hjem,\nformet med omhu",
            intro:
                "Et hjem skal afspejle dem, der bor i det. Derfor arbejder vi med eksklusive renoveringer, tilbygninger og sommerhuse, hvor arkitektur, materialer og detaljer tænkes sammen fra begyndelsen. Med rådgivning, overblik og respekt for visionen skaber vi løsninger, der holder i mange år.",
            valuesTitle: "Hvad du kan forvente",
            v1Title: "Æstetik og funktion",
            v1Text:
                "Vi skaber løsninger, hvor arkitektur, materialer og hverdagsliv går op i en højere enhed. Smukke rammer skal også fungere i praksis.",
            v2Title: "Detalje og finish",
            v2Text:
                "Vi tror på, at kvalitet findes i detaljerne. Derfor arbejder vi med stor præcision og respekt for de materialer, vi bygger med.",
            v3Title: "Ro og overblik",
            v3Text:
                "Du får en samarbejdspartner, der skaber struktur gennem hele processen og sikrer, at beslutninger træffes på et oplyst grundlag.",
            v4Title: "Langsigtet værdi",
            v4Text:
                "Vi bygger med fokus på holdbarhed, kvalitet og løsninger, der bevarer deres værdi — både æstetisk og funktionelt — over tid.",
            processTitle: "Sådan arbejder vi",
            step1: "Indledende samtale",
            step1Text:
                "Vi starter med at forstå dine ønsker, behov og ambitioner for projektet. Det giver det rette grundlag for de beslutninger, der følger.",
            step2: "Projektudvikling",
            step2Text:
                "Vi rådgiver om løsninger, materialer og muligheder, så projektet udvikles med respekt for både arkitektur, funktion og økonomi.",
            step3: "Udførelse",
            step3Text:
                "Når byggeriet går i gang, sikrer vi høj kvalitet i udførelsen og et tæt samarbejde mellem alle involverede parter.",
            step4: "Aflevering",
            step4Text:
                "Vi afslutter først, når detaljerne er på plads, og resultatet lever op til den vision, projektet blev skabt ud fra.",
            cta: "Book en indledende samtale",
            ctaTitle: "Lad os tale om dit projekt",
            ctaText:
                "Uanset om du står foran en større renovering, en tilbygning eller et nyt sommerhus, tager vi gerne en indledende samtale om dine ønsker, muligheder og ambitioner for projektet.",
        },
        arkitekter: {
            eyebrow: "For arkitekter",
            title: "Eksekvering i\nrespekt for tegningen",
            intro:
                "De bedste projekter opstår, når arkitektur og udførelse arbejder mod samme mål. Vi samarbejder med arkitekter om eksklusive renoveringer, tilbygninger og sommerhuse, hvor materialer, proportioner og detaljer skal omsættes med præcision og respekt for den oprindelige vision.",
            philosophyLabel: "— Samarbejdsfilosofi",
            philosophy:
                "Vi ser os selv som en forlængelse af arkitektens arbejde. Derfor handler samarbejdet ikke kun om at bygge korrekt, men om at forstå intentionen bag projektet og sikre, at materialer, proportioner og detaljer realiseres, som de er tænkt. Målet er altid det samme: et resultat, der styrker både projektet, relationen til kunden og arkitektens vision.",
            capTitle: "Kompetencer",
            c1: "Tegningsforståelse",
            c1Text:
                "Vi arbejder med respekt for arkitekturens intention og har fokus på at omsætte tegninger til løsninger, uden at detaljerne går tabt undervejs.",
            c2: "Materialevalg",
            c2Text:
                "Vi forstår, hvordan materialer påvirker både æstetik, funktion og oplevelse, og bidrager med faglig sparring, når det skaber værdi for projektet.",
            c3: "Projektledelse",
            c3Text:
                "Vi skaber struktur, fremdrift og klar kommunikation gennem hele processen, så samarbejdet fungerer effektivt for både arkitekt og bygherre.",
            c4: "Detaljering",
            c4Text:
                "Vi lægger vægt på de detaljer, der løfter helheden, og arbejder med præcision i udførelsen — fra de store linjer til den sidste finish.",
            cta: "Drøft et samarbejde",
            ctaTitle: "Lad os drøfte et muligt samarbejde",
            ctaText:
                "Vi samarbejder med arkitekter, der arbejder med eksklusive boliger, renoveringer og sommerhuse, hvor kvaliteten i udførelsen er afgørende for det endelige resultat. Tag fat i os, hvis du ønsker en dialog om et konkret projekt eller et muligt samarbejde.",
        },
        about: {
            eyebrow: "Om MM Byggeri & Rådgivning",
            title: "Et hold formet af\nhåndværk og passion",
            intro:
                "Mange af os er vokset op med byggeriet og har lært fra en tidlig alder, at kvalitet skabes af mennesker, der interesserer sig for det, de laver. Den tilgang præger stadig vores arbejde i dag, hvor faglig stolthed, detaljesans og respekt for håndværket er fundamentet i alt, hvad vi bygger.",
            founderLabel: "— Stifteren",
            founderQuote:
                "\u201cJeg har altid været fascineret af de detaljer, de fleste ikke lægger mærke til. Samlingerne, materialerne og de løsninger, der får et projekt til at føles rigtigt. For mig handler godt håndværk ikke kun om at bygge noget, der fungerer. Det handler om at skabe noget, man kan være stolt af i mange år frem.\u201d",
            founderName: "Martin Madsen",
            founderRole: "Stifter & Indehaver",
            valuesTitle: "Vores værdier",
            val1: "Ordentlighed",
            val1Text:
                "Vi gør os umage, holder vores aftaler og møder mennesker med respekt. Det gælder både kunder, samarbejdspartnere og hinanden.",
            val2: "Detaljesans",
            val2Text:
                "Vi tror på, at de bedste resultater skabes gennem omtanke for både helheden og de små detaljer, der løfter oplevelsen.",
            val3: "Medaljetømrere",
            val3Text:
                "Vi stiller høje krav til vores håndværk og arbejder målrettet med at udvikle dygtige fagfolk, der tager kvalitet personligt.",
            val4: "Samarbejde",
            val4Text:
                "De stærkeste projekter opstår, når mennesker arbejder mod det samme mål. Derfor bygger vi relationer på tillid, dialog og fælles ambitioner.",
        },
        contact: {
            eyebrow: "Kontakt",
            title: "Lad os tale om\ndit projekt",
            intro:
                "Uanset om du står foran en eksklusiv renovering, en tilbygning eller et nyt sommerhus, tager vi gerne en indledende dialog om dine ønsker, tanker og ambitioner. De bedste projekter starter med en god samtale.",
            studio: "Studie",
            studioAddress: "H P Christensens Vej 1\n3000 Helsingør",
            phone: "Telefon",
            email: "E-mail",
            hours: "Åbningstider",
            hoursText: "Mandag–Fredag\n08:00–16:00",
            formTitle: "Skriv til os",
            name: "Navn",
            emailField: "E-mail",
            phoneField: "Telefon (valgfri)",
            projectType: "Projekttype",
            projectPrivate: "Privat bygherre",
            projectArch: "Arkitekt",
            projectOther: "Andet",
            message: "Besked",
            send: "Send besked",
            sending: "Sender…",
            success: "Tak — vi vender tilbage hurtigst muligt.",
            error: "Udfyld venligst navn, e-mail og besked.",
        },
        footer: {
            tag: "Eksklusivt håndværk i øjenhøjde",
            navigation: "Navigation",
            visit: "Besøg",
            connect: "Kontakt",
            legal: "Information",
            cookiePolicy: "Cookie-politik",
            terms: "Vilkår & betingelser",
            rights: "Alle rettigheder forbeholdes.",
            cvr: "CVR",
            companyLegal: "MM Byggeri og Rådgivning ApS",
            gazelle: "Børsen Gazelle",
        },
    },
};
